import type {
	RulesLogic,
	ValueDecoration,
} from '@jira/polaris__domain-field/src/ValueDecoration.types.tsx';
import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import type { FieldRemote } from '@jira/polaris__remote-field/src/FieldRemote.types.tsx';

type UpdateParams = {
	fieldKey: FieldKey;
	fieldRemote: FieldRemote;
	existingDecorations: ValueDecoration[];
	newDecorations: ValueDecoration[];
};

export const remapValueDecorations = (
	decorations: ValueDecoration[],
):
	| {
			valueDecorations: {
				highlightContainer: boolean | undefined;
				logic: RulesLogic;
				emoji?: string | undefined;
				backgroundColor?: string | undefined;
			}[];
	  }
	| {
			valueDecorations?: undefined;
	  } =>
	decorations.length > 0
		? {
				valueDecorations: decorations.map((decoration) => ({
					...(decoration.backgroundColor ? { backgroundColor: decoration.backgroundColor } : {}),
					...(decoration.emoji ? { emoji: decoration.emoji } : {}),
					highlightContainer: decoration.highlightContainer,
					logic: decoration.logic,
				})),
			}
		: {};

export const performJiraConfigurationUpdate = ({
	fieldKey,
	fieldRemote,
	existingDecorations,
	newDecorations,
}: UpdateParams): Promise<void> => {
	const oldConfiguration = remapValueDecorations(existingDecorations);
	const configuration = remapValueDecorations(newDecorations);
	return fieldRemote.updateFieldConfiguration({
		fieldKey,
		oldConfiguration,
		configuration,
		type: 'updateFieldDecorations',
	});
};
